import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useAppData } from '../../../../features/providers/app-data-provider';
import { useBreadcrumbs } from '../../../../features/providers/breadcrumbs-provider';
import Div from '../../div';
const DefaultAppHeader = ({ withoutPaddingHorizontal, withoutPaddingRight, withoutPaddingLeft, style, beforeHeader, }) => {
    const { header } = useAppData();
    return (_jsxs("div", { style: Object.assign(Object.assign({}, style), { width: '100%', paddingRight: withoutPaddingHorizontal || withoutPaddingRight ? 60 : 0, paddingLeft: withoutPaddingHorizontal || withoutPaddingLeft ? 60 : 0 }), children: [beforeHeader && _jsx(Div, { children: beforeHeader }), header] }));
};
const AdminAppHeader = ({ withoutPaddingRight, withoutPaddingHorizontal, style, beforeHeader, }) => {
    const { header } = useAppData();
    if (!header)
        return _jsx(_Fragment, {});
    return (_jsxs("div", { style: Object.assign({ position: 'sticky', zIndex: 100, width: '100%', top: 0, transition: 'left 200ms linear', paddingRight: withoutPaddingHorizontal || withoutPaddingRight ? 60 : 0, paddingLeft: withoutPaddingHorizontal ? 60 : 0 }, style), children: [!!beforeHeader && _jsx("div", { children: beforeHeader }), header] }));
};
const AppHeader = (props) => {
    const { app, breadcrumbs } = props;
    const { setBreadCrumbs } = useBreadcrumbs();
    useEffect(() => {
        setBreadCrumbs(breadcrumbs);
    }, [breadcrumbs]);
    return app === 'admin' ? (_jsx(AdminAppHeader, Object.assign({}, props))) : (_jsx(DefaultAppHeader, Object.assign({}, props)));
};
export default AppHeader;
